<h1 mat-dialog-title>
    <span [translate]="'admin.parametres.authentification.listeNoire.ajout.title'"></span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content class="py-1">
    <form autocomplete="off">
        <fieldset>
            <div class="row">
                <custom-input
                        ngDefaultControl
                        name="motDePasse"
                        libelle="admin.parametres.authentification.listeNoire.ajout.motDePasse"
                        customType="input"
                        optionDisplay="libelle"
                        id="motDePasse"
                        [(ngModel)]="motDePasse"
                        [lCol]="4"
                        [rCol]="8"
                ></custom-input>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label for="fichier">
                        <span translate>admin.parametres.authentification.listeNoire.ajout.dictionnaire</span>
                    </label>
                </div>
                <div class="col-md-8 flex justify-content-center row">
                    <div class="col-md-7">
                        <input type="file" class="form-control-file" id="fichier" name="fichier" (change)="onFileChange($event)">
                    </div>
                    <div class="col-md-5">
                        <mat-icon
                                matSuffix class="material-icons-outlined"
                                [class.clickable]="true"
                                [matTooltip]="'admin.parametres.authentification.listeNoire.ajout.dictionnaireTooltip' | translate">
                            {{ 'info' }}
                        </mat-icon>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="action-row d-flex flex-row-reverse">
    <div class="end-actions">
        <button mat-flat-button color="primary" [mat-dialog-close]>
            <span *ngIf="!isSaving" translate>global.actions.annuler</span>
            <mat-spinner class="m-5" diameter="28" *ngIf="isSaving"></mat-spinner>
        </button>
        <button mat-flat-button color="primary" (click)="onSave()" [disabled]="isSaveDisabled()">
            <span *ngIf="!isSaving" translate>global.actions.ajouter</span>
            <mat-spinner class="m-5" diameter="28" *ngIf="isSaving"></mat-spinner>
        </button>
    </div>
</div>

